import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Animated from '../AnimatedLetters/Animated';
import './Experience.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faDatabase, faLaptopCode, faRobot } from '@fortawesome/free-solid-svg-icons';

const Experience = () => {
    const [letterClass, setLetterClass] = useState('text-animate');

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 3000);
    }, []);

    const experiences = [
        {
            title: "Learning Management System",
            description: "Developed a comprehensive LMS with course management, student progress tracking, and interactive learning materials",
            skills: "React, Django REST Framework, PostgreSQL",
            icon: faLaptopCode
        },
        {
            title: "School Management System",
            description: "Built a complete solution for managing school operations including student records, attendance, grading and admin functions",
            skills: "React, Django REST Framework, Redux, JWT Authentication",
            icon: faDatabase
        },
        {
            title: "Student Management System",
            description: "Created a dedicated system for tracking student information, academic performance, and enrollment management",
            skills: "React, Django REST Framework, SQL Database, API Integration",
            icon: faCode
        },
        {
            title: "AI Integration Projects",
            description: "Implemented AI/ML capabilities into existing applications for enhanced features and automation",
            skills: "Node/express, AI/ML Libraries, LLM API Integration",
            icon: faRobot
        }
    ];

    return (
        <Container fluid="md" className="experience-section">
            <h1 className="text-start">
                <Animated
                    letterClass={letterClass}
                    strArray={['P', 'r', 'o', 'f', 'e', 's', 's', 'i', 'o', 'n', 'a', 'l', ' ', 'W', 'o', 'r', 'k']}
                    idx={15}
                />
            </h1>
            <Row className="mt-5">
                {experiences.map((exp, index) => (
                    <Col xs={12} sm={12} md={6} key={index} className="mb-4">
                        <Card className="experience-card">
                            <Card.Body>
                                <div className="icon-container">
                                    <FontAwesomeIcon icon={exp.icon} color="#ffd700" size="2x" />
                                </div>
                                <Card.Title>{exp.title}</Card.Title>
                                <Card.Text>
                                    {exp.description}
                                </Card.Text>
                                <div className="skills-container">
                                    <span className="skills-text">Tech Stack: </span>
                                    <span className="skills-list">{exp.skills}</span>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
            <div className="experience-note">
                <p>These projects were developed as part of my professional work experience and are not publicly available in my personal GitHub repositories. Most projects utilize React for frontend and Django REST Framework for backend services.</p>
            </div>
        </Container>
    );
};

export default Experience;